import React from "react";

import { Button, Label, Message } from "@components";
import { If } from "shared/components/control-statements";
import LazyInput from "shared/components/LazyInput";
import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { CustomerAPI } from "providers/CustomerAPI";
import { Phone } from "shared/utils/Phone";
import { Icon } from "shared/components/core/Icon";

export default class ManualConfirmLoginDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      option: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible === true) {
      this.reset();
    }
  }

  reset() {
    this.setState({
      option: null,
      loading: false,
    });
  }

  async findOptions(term) {
    const customerResponse = await CustomerAPI.getCustomers({
      term,
      page: 0,
      limit: 100,
    });

    const customers = customerResponse.getData([]);

    this.setState({
      option: null,
    });

    return customers.map((customer) => {
      const phone = Phone.mask(customer.phone);
      return {
        id: customer.id,
        label: `${phone} - ${customer.email}`,
        name: customer.name,
      };
    });
  }

  async save() {
    const { option } = this.state;
    const { onClose } = this.props;

    this.setState({
      loading: true,
    });

    const customerId = option.id;

    const confirmResponse = await CustomerAPI.confirmLogin(customerId);

    if (confirmResponse.getErrors([]).length > 0) {
      this.setState({
        loading: false,
      });

      return alert({ text: confirmResponse.getErrors()[0], buttonText: "Ok" });
    }

    this.setState({
      loading: false,
    });

    alert({ text: "Liberação realizada com sucesso", buttonText: "Ok" });

    onClose && onClose();
  }

  render() {
    const { loading, option } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        showBackButton
        showCloseButton={false}
        backButton={() => onClose()}
        title="Liberar confirmação de um cliente"
        subtitle="Validações de cadastro"
      >
        <div className={styles.secretDrawerContainer}>
          <Message
            icon={false}
            text="Após realizar a liberação, peça ao usuário que tente novamente."
            className="mb-20"
          />

          <LazyInput
            placeholder="Buscar por..."
            minTextLength={1}
            design="search"
            fillText={false}
            onOption={(option) => {
              this.setState({ option: option });
            }}
            findOptions={(term) => this.findOptions(term)}
          />

          <If cond={option}>
            <div className={styles.customer}>
              <div className="d-flex align-center justify-between w-100">
                <p className={styles.name}>{option?.name}</p>
                <div
                  className={styles.remove}
                  onClick={() => this.setState({ option: null })}
                >
                  <Icon name="times" />
                </div>
              </div>
              <p className={styles.label}>{option?.label}</p>
            </div>
          </If>
        </div>

        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.save()}
            loading={loading}
            disabled={loading || !option}
          >
            Liberar este cliente
          </Button>
        </div>
      </Drawer>
    );
  }
}
